import React,{useEffect,useState} from "react";
import { Row, Col, Typography, Skeleton } from "antd";
import moment from "moment";
const { Title,Text } = Typography;
const StatCard = ({ title, helpText, bgColor }) => {
  return (
    <div
      style={{
        backgroundColor: bgColor,
        marginRight: "20px",
        borderRadius:8,
        padding: "20px",
      }}
    >
      <Row>
        <Text style={{marginBottom:8}}>{helpText}</Text>
      </Row>
      <Row>
        <Title level={4}>{title}</Title>
      </Row>
    </div>
  );
};

export default function Stats({data}) {
  const [stats,setStats] = useState([]);
  useEffect(() => {

    if(data){
      setStats(
        [
            {
              title: data?.last_opened_in?data?.last_opened_in:"- -",
              helpText: "Last opened in",
              bgColor: "#F0F8F6",
            },
            {
              title:  data?.last_session_on ? moment(data?.last_session_on).format('MMMM Do YYYY'): " - -",
              helpText: "Recent session on",
              bgColor: "#F1F7FF",
            },
            {
              title: data?.num_sessions,
              helpText: "Number of sessions",
              bgColor: "#F5F5F5",
            },
            {
              title: moment.utc(data?.total_time_spent_seconds*1000).format('HH:mm:ss') ,
              helpText: "Overall time spent",
              bgColor: "#F3EFFD",
            },
          ]

      )
    }
  }, [data]);
  
 
 
  return (
    <div style={{ marginTop: "2em" }}>
      <Row>
        {stats.length  > 0 ? stats.map((item, index) => {
          return (
            <Col span={6} key={index}>
              <StatCard {...item} />
            </Col>
          );
        }) : <Skeleton.Input active size="large"  />}
      </Row>
    </div>
  );
}
